// import * as Config from '../../../../config';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";

import FixedSizeList from './FixedSizeList';
import Linkage from '../../common/Linkage';
import BlockLoading from '../../common/BlockLoading';

function ListColumns({
  id, pathApi, title = null, titleClassName, subTitle = null, subTitleClassName, width, height, columnCount = 1, rowCount = 1, size, rowType = `Column`,
  hasPagination = false, allTo = null, allLabel = `View All`, style, enableArrows = false,
  linkToUID = null
}) {
  const gap = 16;
  const widthByColumn = (width - ((columnCount - 1) * gap)) / columnCount;
  const [columns, setColumns] = useState([...new Array(columnCount)].map( (x, i) => ({
    index: i,
    pathApi: `${pathApi}${pathApi.includes(`?`) ? '&' : '?'}per_page=${rowCount}&page=${i + 1}`,
    data: []
  })))

  const stack = useSelector( state => state.stackAutomix);
  useEffect(() => {
    if (linkToUID) {
      const data = (Array.isArray(stack)) ? stack.find( x => x.uid === linkToUID ) : ((stack.uid === linkToUID) ? stack : null)
      setColumns(columns.map( (x,i) => {
        x.data = (data) ? data.tracks.slice(i * rowCount, (i + 1) * rowCount) : []
        return x;
      })); 
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [linkToUID, stack, rowCount])
  const isDataReady = columns.every( x => x.data.length > 0 ) || linkToUID === null;

  const [visible, setVisible] = useState(true);
  const callbackEmpty = () => { setVisible(false) }

  return visible ? (
    <div style={{...style}}>
      <div className={`flexRow list-columns-headers`}>
        { title 
          ? <span className={`bp-h5 type-regular type-light`}>
              <span className={titleClassName}>{title}</span>
              {subTitle && <span className={subTitleClassName}>{subTitle}</span> }
            </span> 
          : null 
        }
        { hasPagination ? (
          <div className={`flexRow list-columns-pagination`}>
            <Linkage label={allLabel} to={allTo} style={{zIndex: 10}} linkClassName={`pag-all type-medium fz13`} />
          </div>
        ) : null }
      </div>
      <div className={`flexRow list-columns-container`}>
        { (linkToUID && !isDataReady) && <BlockLoading height={height} style={{ marginTop: 12 }} /> }
        { isDataReady && columns.map( (column, i) => (
            <FixedSizeList
              key={`listColumn-${column.index}`}
              id={`${id}-[${column.index}]`}
              width={widthByColumn /*- ((i % 2 === 0) ? Config.LC_PAD_BETWEEN : 0)*/}
              height={height}
          
              pathApi={!linkToUID ? column.pathApi : null}
              data={linkToUID ? column.data : null}
          
              rowSize={size}
              rowType={rowType}
              sortable={false}
              enableArrows={enableArrows}
          
              style={{/* paddingRight: (i % 2 === 0) ? Config.LC_PAD_BETWEEN : 0 */}}
              styleLoading={{ marginLeft: 15, marginTop: 12 }}
              showLoading={(i === 0)}

              callbackEmpty={callbackEmpty}
            />
          ) )
        }
      </div>
    </div>
  ) : null
}



ListColumns.propTypes = {
  id: PropTypes.any.isRequired,
  pathApi: PropTypes.string.isRequired,
  title: PropTypes.string,
  titleClassName: PropTypes.string,
  subTitle: PropTypes.string,
  subTitleClassName: PropTypes.string,
  allLabel: PropTypes.string,
  allTo: PropTypes.string,
  width: PropTypes.any.isRequired,
  height: PropTypes.any.isRequired,
  size: PropTypes.number.isRequired,
  rowType: PropTypes.string.isRequired,
  enableArrows: PropTypes.bool,
  style: PropTypes.object,
}

export default React.memo(ListColumns); // IF BAD PERFORMANCE REMOVE
